/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function BoxFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="box-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.625 5.5C2.663 4.769 2.995 3.939 3.467 3.467C3.939 2.995 4.769 2.663 5.5 2.625L11.125 2.625L11.125 8C11.125 8.483 11.517 8.875 12 8.875C12.483 8.875 12.875 8.483 12.875 8L12.875 2.625L18.5 2.625C19.231 2.663 20.061 2.995 20.533 3.467C21.005 3.939 21.337 4.769 21.375 5.5L21.375 18.5C21.337 19.231 21.005 20.061 20.533 20.533C20.061 21.005 19.231 21.337 18.5 21.375L5.5 21.375C4.769 21.337 3.939 21.005 3.467 20.533C2.995 20.061 2.663 19.231 2.625 18.5L2.625 5.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
    </svg>
  )
}
